
import React from 'react';
import { Link } from 'react-router-dom';

const About: React.FC = () => {
  return (
    <div className="w-full">
      <section className="relative h-[60vh] flex flex-col items-center justify-center text-center overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 to-white z-10"></div>
          <img 
            src="/original.png" 
            className="w-full h-full object-cover grayscale opacity-90" 
            alt="Sobre SANAN" 
          />
        </div>
        <div className="relative z-20 flex flex-col gap-4 max-w-4xl px-6 animate-fade-in">
          <h1 className="text-white text-5xl md:text-8xl font-black uppercase leading-[0.85] tracking-tighter italic">
            Originalidad en <br/>cada detalle.
          </h1>
          <p className="text-gray-200 text-lg md:text-xl font-light mt-4">Cada prenda nace de una idea propia y se convierte en una pieza exclusiva para tu día a día.</p>
        </div>
      </section>

      <section className="max-w-[1000px] mx-auto py-32 px-6 flex flex-col md:flex-row gap-20">
        <div className="flex-1 space-y-6">
          <h2 className="text-4xl font-black uppercase tracking-tight italic">Precisión en cada puntada.</h2>
          <div className="h-1 w-20 bg-black"></div>
        </div>
        <div className="flex-[1.5] space-y-12">
          <div>
            <h3 className="text-black text-sm font-bold uppercase tracking-widest mb-4">Inspirados en el Motorsport</h3>
            <p className="text-gray-500 text-lg leading-relaxed font-light">
              SANAN nace de la pasión por el motor y el diseño exclusivo. Porque vestir inspirado en motorsport también puede ser vestir con estilo. Cada prenda combina originalidad y elegancia para tu día a día.
            </p>
          </div>
          <div>
            <h3 className="text-black text-sm font-bold uppercase tracking-widest mb-4">Hecho para durar</h3>
            <p className="text-gray-500 text-lg leading-relaxed font-light">
              Calidad que se nota al tacto y estilo que perdura: cada prenda está diseñada para destacar con personalidad, siempre.
            </p>
          </div>
        </div>
      </section>

      <section className="max-w-[1200px] mx-auto pb-32 px-6">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-7 relative rounded-2xl overflow-hidden group">
            <img src="/esquena.png" className="w-full h-full object-cover grayscale group-hover:scale-105 transition-transform duration-1000" alt="Lifestyle" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-10">
              <div>
                <span className="text-white/70 text-xs font-bold uppercase tracking-widest">Estilo de Vida</span>
                <h3 className="text-white text-3xl font-bold italic uppercase">Estilo sin Compromisos</h3>
              </div>
            </div>
          </div>
          <div className="md:col-span-5 flex flex-col gap-8">
            <div className="flex-1 relative rounded-2xl overflow-hidden">
               <img src="/alonso.png" className="w-full h-full object-cover" alt="Detalle" />
            </div>
            <div className="flex-1 bg-gray-50 rounded-2xl p-10 flex flex-col justify-center border border-gray-100">
               <h3 className="text-black font-black uppercase tracking-widest text-lg mb-4 italic">Materiales Premium</h3>
               <p className="text-gray-500 font-light">Seleccionamos tejidos de alta calidad, cómodos y duraderos, para que cada prenda combine estilo y confort en tu día a día.</p>
               <Link to="/shop" className="text-black font-bold uppercase tracking-widest text-xs mt-6 flex items-center gap-2 italic">
                 Explorar en la tienda
                 <span className="material-symbols-outlined text-sm">arrow_forward</span>
               </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
